import { updateChatbotState } from "./Utils";
import {API_BASE} from "../../../services/apirest";

export const confirmarInsercionCliente = async (datosCliente, setState, createChatBotMessage) => {
  try {
    // Realiza la petición POST al endpoint de inserción
    const response = await fetch(`${API_BASE}/insertClienteEndpoint.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(datosCliente)
    });

    if (!response.ok) {
      throw new Error("Error al insertar el cliente en la API");
    }

    const result = await response.json();

    if (result.status !== "OK") {
      // Notifica al usuario si ocurrió algún error en la inserción
      return updateChatbotState(
          setState,
          createChatBotMessage(`No se pudo insertar el cliente: ${result.result?.error_msg || "Error desconocido"}`)
      );
    }

    // Si la inserción es exitosa, notifica al usuario con el ID del cliente insertado
    updateChatbotState(
        setState,
        createChatBotMessage(`Cliente insertado correctamente. ID: ${result.cliente.id}`)
    );
  } catch (error) {
    updateChatbotState(
        setState,
        createChatBotMessage(`Hubo un error al insertar el cliente: ${error.message}`)
    );
  }
};